import { getContext, track } from '../core';

const SELECTORS = '.single-event__register-btn, [data-sticky-cta] button, [data-sticky-cta] a';

export function initEventPageTracking(): void {
  const ctx = getContext();
  if (ctx.page_type !== 'event') return;

  document.addEventListener('click', (e) => {
    const target = (e.target as HTMLElement).closest(SELECTORS);
    if (!target) return;

    track('event_register_now', {
      event_title: ctx.article_title || ctx.page_title,
      page_name: ctx.page_title,
    });
  });
}
